import { SVGProps } from "react";

export default function CalendarEditIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, stroke = "#6B6B6B", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.33594 1.33301V3.33301"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6641 1.33301V3.33301"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33594 6.05957H13.6693"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8099 10.5129L10.45 12.8729C10.3566 12.9662 10.2699 13.1395 10.2499 13.2662L10.1233 14.1662C10.0766 14.4929 10.3033 14.7195 10.6299 14.6729L11.53 14.5462C11.6566 14.5262 11.8366 14.4395 11.9233 14.3462L14.2833 11.9862C14.69 11.5795 14.8833 11.1062 14.2833 10.5062C13.69 9.91288 13.2166 10.1062 12.8099 10.5129Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4688 10.8535C12.6688 11.5735 13.2288 12.1335 13.9488 12.3335"
        stroke="#292D32"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8.71967V5.66634C2 3.66634 3 2.33301 5.33333 2.33301H10.6667C13 2.33301 14 3.66634 14 5.66634V7.99967"
        stroke="#292D32"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14.6663H5.33333C3 14.6663 2 13.333 2 11.333"
        stroke="#292D32"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99373 9.13314H7.99972"
        stroke="#292D32"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5328 9.13314H5.53878"
        stroke="#292D32"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5328 11.1331H5.53878"
        stroke="#292D32"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
